import * as Yup from 'yup';

// const Yup = require('yup');

Yup.addMethod(Yup.object, 'atLeastOneOf', function (list, message) {
  return this.test({
    name: 'atLeastOneOf',
    message,
    exclusive: true,
    test(value) {
      if (value == null || list.some(f => value[f] != null)) {
        return true;
      }
      return this.createError({ path: 'atLeastOneOf' });
    },
  });
});

export default Yup;


// WEBPACK FOOTER //
// ./src/utilities/yupExtensions.js